import {
  SET_HUBBLE_FORMS,
  SET_SINGLE_HUBBLE_FORM,
  SET_HUBBLE_CURRENT_PAGE,
  SET_HUBBLE_TOTAL_DOCS,
  SET_HUBBLE_TOTAL_PAGES,
  SET_HUBBLE_JUDGES,
  SET_HUBBLE_REFEREE,
  SET_HUBBLE_REFEREE_CURRENT_PAGE,
  SET_HUBBLE_REFEREE_TOTAL_DOCS,
  SET_HUBBLE_REFEREE_TOTAL_PAGES,
  SET_SINGLE_HUBBLE_REFEREE,
  SET_SELECTED_JUDGE
} from "../../@jumbo/constants/ActionTypes";

export const setHubbleForms = (forms) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_FORMS,
      payload: forms,
    });
  };
};

export const setHubbleCurrentpage = (currentpage) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_CURRENT_PAGE,
      payload: currentpage,
    });
  };
};

export const setHubbleTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};

export const setHubbleTotalDocs = (totalDocs) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_TOTAL_DOCS,
      payload: totalDocs,
    });
  };
};

export const setSingleHubbleForm = (form) => {
  return (dispatch) => {
    dispatch({
      type: SET_SINGLE_HUBBLE_FORM,
      payload: form,
    });
  };
};

export const setHubbleJudges = (form) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_JUDGES,
      payload: form,
    });
  };
};

export const setHubbleReferee = (referees) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_REFEREE,
      payload: referees,
    });
  };
};

export const setHubbleRefereeCurrentpage = (page) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_REFEREE_CURRENT_PAGE,
      payload: page,
    });
  };
};

export const setHubbleRefereeTotalDocs = (totalDocs) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_REFEREE_TOTAL_DOCS,
      payload: totalDocs,
    });
  };
};

export const setHubbleRefereeTotalPages = (totalpages) => {
  return (dispatch) => {
    dispatch({
      type: SET_HUBBLE_REFEREE_TOTAL_PAGES,
      payload: totalpages,
    });
  };
};

export const setSingleHubbleReferee = (referee) => {
  return (dispatch) => {
    dispatch({
      type: SET_SINGLE_HUBBLE_REFEREE,
      payload: referee,
    });
  };
};

export const setSelectedJudge = (judge)=>{
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_JUDGE,
      payload: judge,
    });
  };
}
